export const generatingSectionTransformer = (
  t: any,
  generatingMessage: string
): any => ({
  title: t('generating_planning_title') ?? '',
  generatingMessage,
})
